<template>
  <div class="body">
    <topmenu :showLanguageSelector="true" 
             :showInfoButton="true" 
             :showLogoutButton="showLogoutButton" 
             :tenantId="tenantId" 
             @logout="logout" 
             :loginInfo="loginInfo"/>
    <a id="MainContent"></a>

    <slot>
    </slot>
    
  </div>
</template>

<script src="./layout.ts"></script>
<style src="./sign2.css"/>
